module.exports = __webpack_public_path__ + "img/o3.ac76375b.jpg";